import { persisted } from '@square/svelte-store'

export const affiliatePlatformLock = persisted<'default' | 'locked' | 'unlocked'>(
	'default',
	'affiliatePlatformLock',
)
